import React from 'react';
import { connect } from 'react-redux';
import { useQuery } from '@apollo/react-hooks';
import { useHistory, useParams } from 'react-router-dom';

import { AppHeader, CircularLoader } from 'components';

import ConfirmContext from 'contexts/ConfirmContext';

import { getReceivedBookedRentalItemsData } from 'utils/book-rental-items/prepareReceivedBookedRentalItemsData';

import { RENTAL_ITEMS_BOOKING_UPDATE } from 'graphql/queries/rental-items-booking';

import BookRentalItems from 'pages/book-rental-items/BookRentalitems';

import useStyles from './styles';

const UpdateRentalItemsBookingWrapper = ({ businessOwner }) => {
  const classes = useStyles();
  const { id } = useParams();
  const confirm = React.useContext(ConfirmContext);
  const history = useHistory();

  const { loading, error, data } = useQuery(RENTAL_ITEMS_BOOKING_UPDATE, {
    fetchPolicy: 'no-cache',
    notifyOnNetworkStatusChange: true,
    variables: {
      rentalItemsBookingId: parseInt(id),
      businessOwnerId:
        businessOwner.selectedBusinessOwner.ownerId ||
        businessOwner.selectedBusinessOwner.id
    }
  });

  

  if (loading || !businessOwner.selectedBusinessOwner.hasOwnProperty('id')) {
    return (
      <>
        <AppHeader />

        <CircularLoader
          isLoading={true}
          loaderClassName={classes.loaderClassName}
          className={classes.loaderWrapper}
        />
      </>
    );
  }

  if (error || !data.rentalItemsBookings.length) {
    confirm({
      title: 'rental items booking does not exist!',
      confirmationText: 'Back'
    })
      .then(() => history.push('/bookings-rental-items-list'))
      .catch(() => {});

    return <div style={{ height: '100%' }}>{''}</div>;
  }

  const bookedData = loading
    ? null
    : getReceivedBookedRentalItemsData(data.rentalItemsBookings[0]);

    

  return (
    <BookRentalItems
      initialValues={bookedData}
      bookedData={bookedData}
      isUpdate={true}
    />
  );
};

const mapStateToProps = state => ({
  businessOwner: state.businessOwner
});

export default connect(mapStateToProps, null)(UpdateRentalItemsBookingWrapper);
